import { mlsSetStatesList } from '@/utils/helpers/';

const mlsIsState = ( location: string ): boolean => {
    const statesList = mlsSetStatesList();
    return statesList.includes( location.toLowerCase() )
}
export default mlsIsState;



